import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { ConfirmationDialog } from "@dzambalaorg/mui-dialog-confirmation";
import { AddressLink } from "@dzambalaorg/mui-scanner";
import { ILotteryToken } from "@framework/types";

import { decodeNumbers, getNumbers } from "../utils";

export interface ILotteryTokenDialogViewProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  viewItem: ILotteryToken | null;
}

export const LotteryTokenDialogView = (props: ILotteryTokenDialogViewProps) => {
  const { viewItem, onConfirm, open, ...rest } = props;

  if (!open || !viewItem) {
    return null;
  }

  const { tokenId, round, balance, tokenStatus, metadata } = viewItem;

  const handleConfirm = (): void => {
    onConfirm();
  };

  return (
    <ConfirmationDialog open={open} message="dialogs.view" onConfirm={handleConfirm} {...rest}>
      <TableContainer component={Paper}>
        <Table aria-label="lottery token table">
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.lottery" />
              </TableCell>
              <TableCell align="right">{round.contract?.title}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.roundId" />
              </TableCell>
              <TableCell align="right">{round.roundId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.tokenId" />
              </TableCell>
              <TableCell align="right">{tokenId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.numbers" />
              </TableCell>
              <TableCell align="right">{decodeNumbers(metadata.NUMBERS)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.winNumbers" />
              </TableCell>
              <TableCell align="right">
                {round ? (round.numbers ? getNumbers(round.numbers) : "round not yet finished") : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.tokenStatus" />
              </TableCell>
              <TableCell align="right">{metadata.PRIZE ? "PRIZE" : tokenStatus}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <FormattedMessage id="form.labels.account" />
              </TableCell>
              <TableCell align="right">
                <AddressLink address={balance?.at(0)?.account} length={42} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </ConfirmationDialog>
  );
};
